module.exports = __webpack_public_path__ + "static/img/productPartner_10_2.e452551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/productPartner_10_2.png
// module id = B+Hl
// module chunks = 34